const opacity = (value: number): string => `
      opacity: ${value}%;
      -ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=${value})';
      filter: alpha(opacity=${value});
      -moz-opacity: ${value / 100};
      -khtml-opacity: ${value / 100};
    `;

export default opacity;
